import { render, staticRenderFns } from "./CameraSimulator.vue?vue&type=template&id=15d304c5&scoped=true&"
import script from "./CameraSimulator.vue?vue&type=script&lang=js&"
export * from "./CameraSimulator.vue?vue&type=script&lang=js&"
import style0 from "./CameraSimulator.vue?vue&type=style&index=0&id=15d304c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d304c5",
  null
  
)

export default component.exports